import { ReactNode } from 'react';
import * as RadixTooltip from '@radix-ui/react-tooltip';
import cn from 'classnames';
import { FCP } from 'types';

import classes from './index.module.css';

export interface TooltipProps extends FCP {
  trigger: ReactNode;
}

const Trigger = ({ children, ...props }: RadixTooltip.TooltipTriggerProps) => (
  <RadixTooltip.Trigger {...props} asChild>
    <span tabIndex={0}>
      {children}
    </span>
  </RadixTooltip.Trigger>
);

const Content = ({
  children,
  className,
  arrowClassName,
  ...props
}: RadixTooltip.TooltipContentProps & { arrowClassName?: string }) => (
  <RadixTooltip.Portal>
    <RadixTooltip.Content
      className={cn(
        'z-br-4 z-px-20 z-py-16 z-font-14 z-leading-22px z-text-white',
        classes.content,
        className
      )}
      {...props}
    >
      {children}
      <RadixTooltip.Arrow className={cn(classes.arrow, arrowClassName)} width={13} height={7} />
    </RadixTooltip.Content>
  </RadixTooltip.Portal>
);

export const Tooltip = ({ children, ...props }: RadixTooltip.TooltipProps) => {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root {...props}>{children}</RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
};

Tooltip.Trigger = Trigger;
Tooltip.Content = Content;
